import { render, staticRenderFns } from "./customPayment.vue?vue&type=template&id=c7263ce0"
import script from "./customPayment.vue?vue&type=script&lang=js"
export * from "./customPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports